import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, ACCOUNTS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'account',
  url: `${ACCOUNTS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
